import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './MarketFandO.css';
import { useNavigate } from "react-router-dom";

function MarketFandO(props) {
    const [optionType, setOptionType] = useState('');
    const [optionFuture, setOptionFuture] = useState('');
    const [optionOpt, setOptionOpt] = useState('');
    const [option, setOption] = useState('Derivative');
    let getOptionValue = props.optionValue;
    let navigate = useNavigate();

    useEffect(() => {
        if (optionType === "Overview") {
            navigate("/market/futures-and-options");
        }
        if (optionType === "Nifty Futures") {
            navigate("/Futures-And-Options/Nifty-Futures");
        }
        if (optionType === "Top Value Traded") {
            navigate("/Futures-And-Options/Top-Value-Traded");
        }
        if (optionType === "Derivative Summary") {
            navigate("/Futures-And-Options/Derivative-Summary");
        }
        if (optionType === "FII Statistics") {
            navigate("/Futures-And-Options/FII-Statistics");
        }
        if (optionType === "List of underlying Securities") {
            navigate("/Futures-And-Options/List-of-underlying-Securities");
        }
        if (optionType === "Top Quantity") {
            navigate("/Futures-And-Options/Top-Quantity");
        }
        if (optionType === "Put Call Ratio") {
            navigate("/Futures-And-Options/Put-Call-Ratio");
        }
        if (optionType === "Cost of Carry") {
            navigate("/Futures-And-Options/Cost-of-Carry");
        }
        if (optionType === "Position Limit") {
            navigate("/Futures-And-Options/Position-Limit");
        }
        if (optionType === "Derivative News") {
            navigate("/Futures-And-Options/Derivative-News");
        }
        if (optionType === "Roll Over") {
            navigate("/Futures-And-Options/Roll-Over");
        }
         if (optionFuture === "Most Active Contracts") {
            navigate("/Futures-And-Options/Most-Active-Contracts");
        }
        if (optionFuture === "All Index Future") {
            navigate("/Futures-And-Options/All-Index-Future");
        }
        if (optionFuture === "Top Gainers (Futures)") {
            navigate("/Futures-And-Options/Top-Gainers-Futures");
        }
        if (optionFuture === "Top Losers (Futures)") {
            navigate("/Futures-And-Options/Top-Losers-Futures");
        }
        if (optionFuture === "Highest in OI (Futures)") {
            navigate("/Futures-And-Options/Highest-in-OI-Futures");
        }
        if (optionFuture === "Lowest in OI (Futures)") {
            navigate("/Futures-And-Options/Lowest-in-OI-Futures");
        }
        if (optionFuture === "Increase in OI in % (Futures)") {
            navigate("/Futures-And-Options/Increase-in-OI-Futures");
        }
        if (optionFuture === "Decrease in OI in % (Futures)") {
            navigate("/Futures-And-Options/Decrease-in-OI-Futures");
        }
        if (optionOpt === "Most Active Call") {
            navigate("/Futures-And-Options/Most-Active-Call");
        }
        if (optionOpt === "Most Active Put") {
            navigate("/Futures-And-Options/Most-Active-Put");
        }
        if (optionOpt === "Top Gainers (Options)") {
            navigate("/Futures-And-Options/Top-Gainers-Options");
        }
        if (optionOpt === "Top Losers (Options)") {
            navigate("/Futures-And-Options/Top-Losers-Options");
        }
        if (optionOpt === "Highest in OI (Options)") {
            navigate("/Futures-And-Options/Highest-in-OI-Options");
        }
        if (optionOpt === "Lowest in OI (Options)") {
            navigate("/Futures-And-Options/Lowest-in-OI-Options");
        }
        if (optionOpt === "Increase in OI in % (Options)") {
            navigate("/Futures-And-Options/Increase-in-OI-Options");
        }
        if (optionOpt === "Decrease in OI in % (Options)") {
            navigate("/Futures-And-Options/Decrease-in-OI-Options");
        }
        if (optionOpt === "Option Chain") {
            navigate("/Futures-And-Options/Option-Chain");
        }
    }, [optionType, optionOpt, optionFuture]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-selectFno'>
                                    {/* aria-label="Overview" */}
                                    <select aria-label="Derivative" onChange={(event) => { setOption(event.target.value) }}>
                                        <option value="Derivative">Derivative</option>
                                        <option value="Futures">Future</option>
                                        <option value="Options">Options</option>
                                    </select>

                                </div>
                                <div className='market-selectFno'>
                                    {(option === "Derivative") ?
                                    
                                        <select aria-label="Derivative" value={getOptionValue} onChange={(event) => { setOptionType(event.target.value) }}>
                                            <option value="Overview">Overview</option>
                                            <option value="Nifty Futures">Nifty Futures</option>
                                            <option value="Top Value Traded">Top Value Traded</option>
                                            <option value="Derivative Summary">Derivative Summary</option>
                                            <option value="FII Statistics">FII Statistics</option>
                                            <option value="List of underlying Securities">List of underlying Securities</option>
                                            <option value="Top Quantity">Top Quantity</option>
                                            <option value="Put Call Ratio">Put Call Ratio</option>
                                            <option value="Cost of Carry">Cost of Carry</option>
                                            <option value="Position Limit">Position Limit</option>
                                            <option value="Roll Over">Roll Over</option>
                                            <option value="Derivative News">Derivative News</option>
                                        </select> : ''}
                                    {(option === "Futures") ?
                                      
                                      <select aria-label="Select Option" value={getOptionValue} onChange={(event) => { setOptionFuture(event.target.value) }}>
                                            <option>Select</option>
                                            <option value="Most Active Contracts">Most Active Contracts</option>
                                            <option value="All Index Future">All Index Future</option>
                                            <option value="Top Gainers (Futures)">Top Gainers (Futures)</option>
                                            <option value="Top Losers (Futures)">Top Losers (Futures)</option>
                                            <option value="Highest in OI (Futures)">Highest in OI (Futures)</option>
                                            <option value="Lowest in OI (Futures)">Lowest in OI (Futures)</option>
                                            <option value="Increase in OI in % (Futures)">Increase in OI in % (Futures)</option>
                                            <option value="Decrease in OI in % (Futures)">Decrease in OI in % (Futures)</option>
                                        </select> : ''}
                                    {(option === "Options") ?
                                        <select aria-label="Select Option" value={getOptionValue} onChange={(event) => { setOptionOpt(event.target.value) }}>
                                            <option>Select</option>
                                            <option value="Most Active Call">Most Active Call</option>
                                            <option value="Most Active Put">Most Active Put</option>
                                            <option value="Option Chain">Option Chain</option>
                                            <option value="Top Gainers (Options)">Top Gainers (Options)</option>
                                            <option value="Top Losers (Options)">Top Losers (Options)</option>
                                            <option value="Highest in OI (Options)">Highest in OI (Options)</option>
                                            <option value="Lowest in OI (Options)">Lowest in OI (Options)</option>
                                            <option value="Increase in OI in % (Options)">Increase in OI in % (Options)</option>
                                            <option value="Decrease in OI in % (Options)">Decrease in OI in % (Options)</option>
                                        </select> : ''}
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketFandO;